import React from 'react';
import UserAvatar from '../common/UserAvatar';

const tableConfig = (props) => ({
    columns: [
        { title: 'Order ID', field: 'order_id', filterAndSearch: true },
        {
            title: 'Order Date', field: 'order_date_system', filterAndSearch: false,
            render: rowData => <div>{rowData.order_date_system ? (
                <div>
                    <div>{moment.utc(rowData.order_date_system).local().format("DD-MM-YYYY")}</div>
                    <div>{moment.utc(rowData.order_date_system).local().format("h:mm:ss a")}</div>
                </div>
            ) : "-"}</div>
        },
        { title: 'Amount', field: 'net_amount', filterAndSearch: true, },
        {
            title: 'Payment Status', field: 'order_payment.payment_status', filterAndSearch: false,
            render: rowData => <div className='text-capitalize'>{rowData.order_payment.payment_status ? rowData.order_payment.payment_status : "-"}</div>
        },
        {
            title: 'Delivery Status', field: 'order_status', filterAndSearch: false,
            render: rowData => <div className='text-capitalize'>{rowData.order_status ? rowData.order_status.toLowerCase() : "-"}</div>
        }
    ],
})

export const data = [
    {
        "userId": "rirani",
        "jobTitleName": "Developer",
        "firstName": "Romin",
        "lastName": "Irani",
        "preferredFullName": "Romin Irani",
        "employeeCode": "E1",
        "region": "CA",
        "phoneNumber": "408-1234567",
        "emailAddress": "romin.k.irani@gmail.com"
    },
    {
        "userId": "nirani",
        "jobTitleName": "Developer",
        "firstName": "Neil",
        "lastName": "Irani",
        "preferredFullName": "Neil Irani",
        "employeeCode": "E2",
        "region": "CA",
        "phoneNumber": "408-1111111",
        "emailAddress": "neilrirani@gmail.com"
    },
    {
        "userId": "thanks",
        "jobTitleName": "Program Directory",
        "firstName": "Tom",
        "lastName": "Hanks",
        "preferredFullName": "Tom Hanks",
        "employeeCode": "E3",
        "region": "CA",
        "phoneNumber": "408-2222222",
        "emailAddress": "tomhanks@gmail.com"
    },
    {
        "userId": "thankss",
        "jobTitleName": "Program Directorys",
        "firstName": "Toms",
        "lastName": "Hankss",
        "preferredFullName": "Tom Hanksss",
        "employeeCode": "E3s",
        "region": "CAs",
        "phoneNumber": "408-22222222",
        "emailAddress": "tomhanks@gmail.coms"
    }
];

export default tableConfig;